// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v1.181.2
//   protoc               v5.29.3
// source: player_output.proto
/* eslint-disable */
import _m0 from "protobufjs/minimal";
import { sdk_AssetTypeFromJSON, sdk_AssetTypeToJSON, Sdk_CastMediaTrack, Sdk_DeviceCapabilities, Sdk_MediaTrack, Sdk_ThumbnailData, } from "./sdk";
export const protobufPackage = "taf";
export var PlayerOutput_TimeshiftAvailability;
(function (PlayerOutput_TimeshiftAvailability) {
    PlayerOutput_TimeshiftAvailability[PlayerOutput_TimeshiftAvailability["AVAILABLE"] = 0] = "AVAILABLE";
    PlayerOutput_TimeshiftAvailability[PlayerOutput_TimeshiftAvailability["UNAVAILABLE"] = 1] = "UNAVAILABLE";
    PlayerOutput_TimeshiftAvailability[PlayerOutput_TimeshiftAvailability["ELIGIBLE"] = 2] = "ELIGIBLE";
    PlayerOutput_TimeshiftAvailability[PlayerOutput_TimeshiftAvailability["SUBSCRIBABLE"] = 3] = "SUBSCRIBABLE";
    PlayerOutput_TimeshiftAvailability[PlayerOutput_TimeshiftAvailability["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(PlayerOutput_TimeshiftAvailability || (PlayerOutput_TimeshiftAvailability = {}));
export function playerOutput_TimeshiftAvailabilityFromJSON(object) {
    switch (object) {
        case 0:
        case "AVAILABLE":
            return PlayerOutput_TimeshiftAvailability.AVAILABLE;
        case 1:
        case "UNAVAILABLE":
            return PlayerOutput_TimeshiftAvailability.UNAVAILABLE;
        case 2:
        case "ELIGIBLE":
            return PlayerOutput_TimeshiftAvailability.ELIGIBLE;
        case 3:
        case "SUBSCRIBABLE":
            return PlayerOutput_TimeshiftAvailability.SUBSCRIBABLE;
        case -1:
        case "UNRECOGNIZED":
        default:
            return PlayerOutput_TimeshiftAvailability.UNRECOGNIZED;
    }
}
export function playerOutput_TimeshiftAvailabilityToJSON(object) {
    switch (object) {
        case PlayerOutput_TimeshiftAvailability.AVAILABLE:
            return "AVAILABLE";
        case PlayerOutput_TimeshiftAvailability.UNAVAILABLE:
            return "UNAVAILABLE";
        case PlayerOutput_TimeshiftAvailability.ELIGIBLE:
            return "ELIGIBLE";
        case PlayerOutput_TimeshiftAvailability.SUBSCRIBABLE:
            return "SUBSCRIBABLE";
        case PlayerOutput_TimeshiftAvailability.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
export var PlayerOutput_AdType;
(function (PlayerOutput_AdType) {
    PlayerOutput_AdType[PlayerOutput_AdType["UNKNOWN"] = 0] = "UNKNOWN";
    PlayerOutput_AdType[PlayerOutput_AdType["PREROLL"] = 1] = "PREROLL";
    PlayerOutput_AdType[PlayerOutput_AdType["MIDROLL"] = 2] = "MIDROLL";
    PlayerOutput_AdType[PlayerOutput_AdType["POSTROLL"] = 3] = "POSTROLL";
    PlayerOutput_AdType[PlayerOutput_AdType["START"] = 4] = "START";
    PlayerOutput_AdType[PlayerOutput_AdType["FAST_FORWARD"] = 5] = "FAST_FORWARD";
    PlayerOutput_AdType[PlayerOutput_AdType["PAUSE"] = 6] = "PAUSE";
    PlayerOutput_AdType[PlayerOutput_AdType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(PlayerOutput_AdType || (PlayerOutput_AdType = {}));
export function playerOutput_AdTypeFromJSON(object) {
    switch (object) {
        case 0:
        case "UNKNOWN":
            return PlayerOutput_AdType.UNKNOWN;
        case 1:
        case "PREROLL":
            return PlayerOutput_AdType.PREROLL;
        case 2:
        case "MIDROLL":
            return PlayerOutput_AdType.MIDROLL;
        case 3:
        case "POSTROLL":
            return PlayerOutput_AdType.POSTROLL;
        case 4:
        case "START":
            return PlayerOutput_AdType.START;
        case 5:
        case "FAST_FORWARD":
            return PlayerOutput_AdType.FAST_FORWARD;
        case 6:
        case "PAUSE":
            return PlayerOutput_AdType.PAUSE;
        case -1:
        case "UNRECOGNIZED":
        default:
            return PlayerOutput_AdType.UNRECOGNIZED;
    }
}
export function playerOutput_AdTypeToJSON(object) {
    switch (object) {
        case PlayerOutput_AdType.UNKNOWN:
            return "UNKNOWN";
        case PlayerOutput_AdType.PREROLL:
            return "PREROLL";
        case PlayerOutput_AdType.MIDROLL:
            return "MIDROLL";
        case PlayerOutput_AdType.POSTROLL:
            return "POSTROLL";
        case PlayerOutput_AdType.START:
            return "START";
        case PlayerOutput_AdType.FAST_FORWARD:
            return "FAST_FORWARD";
        case PlayerOutput_AdType.PAUSE:
            return "PAUSE";
        case PlayerOutput_AdType.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
export var PlayerOutput_PlaybackStateChanged_State;
(function (PlayerOutput_PlaybackStateChanged_State) {
    PlayerOutput_PlaybackStateChanged_State[PlayerOutput_PlaybackStateChanged_State["STOPPED"] = 0] = "STOPPED";
    PlayerOutput_PlaybackStateChanged_State[PlayerOutput_PlaybackStateChanged_State["BUFFERING"] = 1] = "BUFFERING";
    PlayerOutput_PlaybackStateChanged_State[PlayerOutput_PlaybackStateChanged_State["PAUSED"] = 2] = "PAUSED";
    PlayerOutput_PlaybackStateChanged_State[PlayerOutput_PlaybackStateChanged_State["PLAYING"] = 3] = "PLAYING";
    PlayerOutput_PlaybackStateChanged_State[PlayerOutput_PlaybackStateChanged_State["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(PlayerOutput_PlaybackStateChanged_State || (PlayerOutput_PlaybackStateChanged_State = {}));
export function playerOutput_PlaybackStateChanged_StateFromJSON(object) {
    switch (object) {
        case 0:
        case "STOPPED":
            return PlayerOutput_PlaybackStateChanged_State.STOPPED;
        case 1:
        case "BUFFERING":
            return PlayerOutput_PlaybackStateChanged_State.BUFFERING;
        case 2:
        case "PAUSED":
            return PlayerOutput_PlaybackStateChanged_State.PAUSED;
        case 3:
        case "PLAYING":
            return PlayerOutput_PlaybackStateChanged_State.PLAYING;
        case -1:
        case "UNRECOGNIZED":
        default:
            return PlayerOutput_PlaybackStateChanged_State.UNRECOGNIZED;
    }
}
export function playerOutput_PlaybackStateChanged_StateToJSON(object) {
    switch (object) {
        case PlayerOutput_PlaybackStateChanged_State.STOPPED:
            return "STOPPED";
        case PlayerOutput_PlaybackStateChanged_State.BUFFERING:
            return "BUFFERING";
        case PlayerOutput_PlaybackStateChanged_State.PAUSED:
            return "PAUSED";
        case PlayerOutput_PlaybackStateChanged_State.PLAYING:
            return "PLAYING";
        case PlayerOutput_PlaybackStateChanged_State.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
function createBasePlayerOutput() {
    return {};
}
export const PlayerOutput = {
    encode(_, writer = _m0.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlayerOutput();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return PlayerOutput.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBasePlayerOutput();
        return message;
    },
};
function createBasePlayerOutput_PlaybackStateChanged() {
    return { state: 0 };
}
export const PlayerOutput_PlaybackStateChanged = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.state !== 0) {
            writer.uint32(8).int32(message.state);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlayerOutput_PlaybackStateChanged();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.state = reader.int32();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return { state: isSet(object.state) ? playerOutput_PlaybackStateChanged_StateFromJSON(object.state) : 0 };
    },
    toJSON(message) {
        const obj = {};
        if (message.state !== 0) {
            obj.state = playerOutput_PlaybackStateChanged_StateToJSON(message.state);
        }
        return obj;
    },
    create(base) {
        return PlayerOutput_PlaybackStateChanged.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBasePlayerOutput_PlaybackStateChanged();
        message.state = object.state ?? 0;
        return message;
    },
};
function createBasePlayerOutput_WatchRequested() {
    return {};
}
export const PlayerOutput_WatchRequested = {
    encode(_, writer = _m0.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlayerOutput_WatchRequested();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return PlayerOutput_WatchRequested.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBasePlayerOutput_WatchRequested();
        return message;
    },
};
function createBasePlayerOutput_WatchReceived() {
    return {
        csid: "",
        registerTimeshift: undefined,
        unregisteredTimeshift: undefined,
        youthProtectionPinRequiredAt: undefined,
    };
}
export const PlayerOutput_WatchReceived = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.csid !== "") {
            writer.uint32(10).string(message.csid);
        }
        if (message.registerTimeshift !== undefined) {
            writer.uint32(16).int32(message.registerTimeshift);
        }
        if (message.unregisteredTimeshift !== undefined) {
            writer.uint32(24).int32(message.unregisteredTimeshift);
        }
        if (message.youthProtectionPinRequiredAt !== undefined) {
            writer.uint32(32).int32(message.youthProtectionPinRequiredAt);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlayerOutput_WatchReceived();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.csid = reader.string();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.registerTimeshift = reader.int32();
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.unregisteredTimeshift = reader.int32();
                    continue;
                case 4:
                    if (tag !== 32) {
                        break;
                    }
                    message.youthProtectionPinRequiredAt = reader.int32();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            csid: isSet(object.csid) ? globalThis.String(object.csid) : "",
            registerTimeshift: isSet(object.registerTimeshift)
                ? playerOutput_TimeshiftAvailabilityFromJSON(object.registerTimeshift)
                : undefined,
            unregisteredTimeshift: isSet(object.unregisteredTimeshift)
                ? playerOutput_TimeshiftAvailabilityFromJSON(object.unregisteredTimeshift)
                : undefined,
            youthProtectionPinRequiredAt: isSet(object.youthProtectionPinRequiredAt)
                ? globalThis.Number(object.youthProtectionPinRequiredAt)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.csid !== "") {
            obj.csid = message.csid;
        }
        if (message.registerTimeshift !== undefined) {
            obj.registerTimeshift = playerOutput_TimeshiftAvailabilityToJSON(message.registerTimeshift);
        }
        if (message.unregisteredTimeshift !== undefined) {
            obj.unregisteredTimeshift = playerOutput_TimeshiftAvailabilityToJSON(message.unregisteredTimeshift);
        }
        if (message.youthProtectionPinRequiredAt !== undefined) {
            obj.youthProtectionPinRequiredAt = Math.round(message.youthProtectionPinRequiredAt);
        }
        return obj;
    },
    create(base) {
        return PlayerOutput_WatchReceived.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBasePlayerOutput_WatchReceived();
        message.csid = object.csid ?? "";
        message.registerTimeshift = object.registerTimeshift ?? undefined;
        message.unregisteredTimeshift = object.unregisteredTimeshift ?? undefined;
        message.youthProtectionPinRequiredAt = object.youthProtectionPinRequiredAt ?? undefined;
        return message;
    },
};
function createBasePlayerOutput_PlayerReady() {
    return { duration: undefined, currentPosition: undefined, seekableRange: undefined };
}
export const PlayerOutput_PlayerReady = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.duration !== undefined) {
            writer.uint32(9).double(message.duration);
        }
        if (message.currentPosition !== undefined) {
            writer.uint32(17).double(message.currentPosition);
        }
        if (message.seekableRange !== undefined) {
            PlayerOutput_PlayerReady_TimeRange.encode(message.seekableRange, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlayerOutput_PlayerReady();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 9) {
                        break;
                    }
                    message.duration = reader.double();
                    continue;
                case 2:
                    if (tag !== 17) {
                        break;
                    }
                    message.currentPosition = reader.double();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.seekableRange = PlayerOutput_PlayerReady_TimeRange.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            duration: isSet(object.duration) ? globalThis.Number(object.duration) : undefined,
            currentPosition: isSet(object.currentPosition) ? globalThis.Number(object.currentPosition) : undefined,
            seekableRange: isSet(object.seekableRange)
                ? PlayerOutput_PlayerReady_TimeRange.fromJSON(object.seekableRange)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.duration !== undefined) {
            obj.duration = message.duration;
        }
        if (message.currentPosition !== undefined) {
            obj.currentPosition = message.currentPosition;
        }
        if (message.seekableRange !== undefined) {
            obj.seekableRange = PlayerOutput_PlayerReady_TimeRange.toJSON(message.seekableRange);
        }
        return obj;
    },
    create(base) {
        return PlayerOutput_PlayerReady.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBasePlayerOutput_PlayerReady();
        message.duration = object.duration ?? undefined;
        message.currentPosition = object.currentPosition ?? undefined;
        message.seekableRange = (object.seekableRange !== undefined && object.seekableRange !== null)
            ? PlayerOutput_PlayerReady_TimeRange.fromPartial(object.seekableRange)
            : undefined;
        return message;
    },
};
function createBasePlayerOutput_PlayerReady_TimeRange() {
    return { start: 0, end: 0 };
}
export const PlayerOutput_PlayerReady_TimeRange = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.start !== 0) {
            writer.uint32(8).int32(message.start);
        }
        if (message.end !== 0) {
            writer.uint32(16).int32(message.end);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlayerOutput_PlayerReady_TimeRange();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.start = reader.int32();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.end = reader.int32();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            start: isSet(object.start) ? globalThis.Number(object.start) : 0,
            end: isSet(object.end) ? globalThis.Number(object.end) : 0,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.start !== 0) {
            obj.start = Math.round(message.start);
        }
        if (message.end !== 0) {
            obj.end = Math.round(message.end);
        }
        return obj;
    },
    create(base) {
        return PlayerOutput_PlayerReady_TimeRange.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBasePlayerOutput_PlayerReady_TimeRange();
        message.start = object.start ?? 0;
        message.end = object.end ?? 0;
        return message;
    },
};
function createBasePlayerOutput_MediaChanged() {
    return {
        url: "",
        licenseUrl: undefined,
        prePadding: undefined,
        postPadding: undefined,
        assetType: 0,
        dynamic: false,
        timeshiftAvailability: undefined,
    };
}
export const PlayerOutput_MediaChanged = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.url !== "") {
            writer.uint32(10).string(message.url);
        }
        if (message.licenseUrl !== undefined) {
            writer.uint32(18).string(message.licenseUrl);
        }
        if (message.prePadding !== undefined) {
            writer.uint32(24).int32(message.prePadding);
        }
        if (message.postPadding !== undefined) {
            writer.uint32(32).int32(message.postPadding);
        }
        if (message.assetType !== 0) {
            writer.uint32(40).int32(message.assetType);
        }
        if (message.dynamic !== false) {
            writer.uint32(48).bool(message.dynamic);
        }
        if (message.timeshiftAvailability !== undefined) {
            writer.uint32(56).int32(message.timeshiftAvailability);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlayerOutput_MediaChanged();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.url = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.licenseUrl = reader.string();
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.prePadding = reader.int32();
                    continue;
                case 4:
                    if (tag !== 32) {
                        break;
                    }
                    message.postPadding = reader.int32();
                    continue;
                case 5:
                    if (tag !== 40) {
                        break;
                    }
                    message.assetType = reader.int32();
                    continue;
                case 6:
                    if (tag !== 48) {
                        break;
                    }
                    message.dynamic = reader.bool();
                    continue;
                case 7:
                    if (tag !== 56) {
                        break;
                    }
                    message.timeshiftAvailability = reader.int32();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            url: isSet(object.url) ? globalThis.String(object.url) : "",
            licenseUrl: isSet(object.licenseUrl) ? globalThis.String(object.licenseUrl) : undefined,
            prePadding: isSet(object.prePadding) ? globalThis.Number(object.prePadding) : undefined,
            postPadding: isSet(object.postPadding) ? globalThis.Number(object.postPadding) : undefined,
            assetType: isSet(object.assetType) ? sdk_AssetTypeFromJSON(object.assetType) : 0,
            dynamic: isSet(object.dynamic) ? globalThis.Boolean(object.dynamic) : false,
            timeshiftAvailability: isSet(object.timeshiftAvailability)
                ? playerOutput_TimeshiftAvailabilityFromJSON(object.timeshiftAvailability)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.url !== "") {
            obj.url = message.url;
        }
        if (message.licenseUrl !== undefined) {
            obj.licenseUrl = message.licenseUrl;
        }
        if (message.prePadding !== undefined) {
            obj.prePadding = Math.round(message.prePadding);
        }
        if (message.postPadding !== undefined) {
            obj.postPadding = Math.round(message.postPadding);
        }
        if (message.assetType !== 0) {
            obj.assetType = sdk_AssetTypeToJSON(message.assetType);
        }
        if (message.dynamic !== false) {
            obj.dynamic = message.dynamic;
        }
        if (message.timeshiftAvailability !== undefined) {
            obj.timeshiftAvailability = playerOutput_TimeshiftAvailabilityToJSON(message.timeshiftAvailability);
        }
        return obj;
    },
    create(base) {
        return PlayerOutput_MediaChanged.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBasePlayerOutput_MediaChanged();
        message.url = object.url ?? "";
        message.licenseUrl = object.licenseUrl ?? undefined;
        message.prePadding = object.prePadding ?? undefined;
        message.postPadding = object.postPadding ?? undefined;
        message.assetType = object.assetType ?? 0;
        message.dynamic = object.dynamic ?? false;
        message.timeshiftAvailability = object.timeshiftAvailability ?? undefined;
        return message;
    },
};
function createBasePlayerOutput_CurrentPositionChanged() {
    return { position: 0 };
}
export const PlayerOutput_CurrentPositionChanged = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.position !== 0) {
            writer.uint32(9).double(message.position);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlayerOutput_CurrentPositionChanged();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 9) {
                        break;
                    }
                    message.position = reader.double();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return { position: isSet(object.position) ? globalThis.Number(object.position) : 0 };
    },
    toJSON(message) {
        const obj = {};
        if (message.position !== 0) {
            obj.position = message.position;
        }
        return obj;
    },
    create(base) {
        return PlayerOutput_CurrentPositionChanged.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBasePlayerOutput_CurrentPositionChanged();
        message.position = object.position ?? 0;
        return message;
    },
};
function createBasePlayerOutput_Seeked() {
    return { position: 0, seekedTime: 0 };
}
export const PlayerOutput_Seeked = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.position !== 0) {
            writer.uint32(9).double(message.position);
        }
        if (message.seekedTime !== 0) {
            writer.uint32(17).double(message.seekedTime);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlayerOutput_Seeked();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 9) {
                        break;
                    }
                    message.position = reader.double();
                    continue;
                case 2:
                    if (tag !== 17) {
                        break;
                    }
                    message.seekedTime = reader.double();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            position: isSet(object.position) ? globalThis.Number(object.position) : 0,
            seekedTime: isSet(object.seekedTime) ? globalThis.Number(object.seekedTime) : 0,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.position !== 0) {
            obj.position = message.position;
        }
        if (message.seekedTime !== 0) {
            obj.seekedTime = message.seekedTime;
        }
        return obj;
    },
    create(base) {
        return PlayerOutput_Seeked.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBasePlayerOutput_Seeked();
        message.position = object.position ?? 0;
        message.seekedTime = object.seekedTime ?? 0;
        return message;
    },
};
function createBasePlayerOutput_PlayerStateChanged() {
    return { canSeekForward: false, canSeekBackward: false, canPause: false, seekableRange: undefined };
}
export const PlayerOutput_PlayerStateChanged = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.canSeekForward !== false) {
            writer.uint32(8).bool(message.canSeekForward);
        }
        if (message.canSeekBackward !== false) {
            writer.uint32(16).bool(message.canSeekBackward);
        }
        if (message.canPause !== false) {
            writer.uint32(24).bool(message.canPause);
        }
        if (message.seekableRange !== undefined) {
            PlayerOutput_PlayerStateChanged_TimeRange.encode(message.seekableRange, writer.uint32(34).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlayerOutput_PlayerStateChanged();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.canSeekForward = reader.bool();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.canSeekBackward = reader.bool();
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.canPause = reader.bool();
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.seekableRange = PlayerOutput_PlayerStateChanged_TimeRange.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            canSeekForward: isSet(object.canSeekForward) ? globalThis.Boolean(object.canSeekForward) : false,
            canSeekBackward: isSet(object.canSeekBackward) ? globalThis.Boolean(object.canSeekBackward) : false,
            canPause: isSet(object.canPause) ? globalThis.Boolean(object.canPause) : false,
            seekableRange: isSet(object.seekableRange)
                ? PlayerOutput_PlayerStateChanged_TimeRange.fromJSON(object.seekableRange)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.canSeekForward !== false) {
            obj.canSeekForward = message.canSeekForward;
        }
        if (message.canSeekBackward !== false) {
            obj.canSeekBackward = message.canSeekBackward;
        }
        if (message.canPause !== false) {
            obj.canPause = message.canPause;
        }
        if (message.seekableRange !== undefined) {
            obj.seekableRange = PlayerOutput_PlayerStateChanged_TimeRange.toJSON(message.seekableRange);
        }
        return obj;
    },
    create(base) {
        return PlayerOutput_PlayerStateChanged.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBasePlayerOutput_PlayerStateChanged();
        message.canSeekForward = object.canSeekForward ?? false;
        message.canSeekBackward = object.canSeekBackward ?? false;
        message.canPause = object.canPause ?? false;
        message.seekableRange = (object.seekableRange !== undefined && object.seekableRange !== null)
            ? PlayerOutput_PlayerStateChanged_TimeRange.fromPartial(object.seekableRange)
            : undefined;
        return message;
    },
};
function createBasePlayerOutput_PlayerStateChanged_TimeRange() {
    return { start: 0, end: 0 };
}
export const PlayerOutput_PlayerStateChanged_TimeRange = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.start !== 0) {
            writer.uint32(8).int32(message.start);
        }
        if (message.end !== 0) {
            writer.uint32(16).int32(message.end);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlayerOutput_PlayerStateChanged_TimeRange();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.start = reader.int32();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.end = reader.int32();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            start: isSet(object.start) ? globalThis.Number(object.start) : 0,
            end: isSet(object.end) ? globalThis.Number(object.end) : 0,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.start !== 0) {
            obj.start = Math.round(message.start);
        }
        if (message.end !== 0) {
            obj.end = Math.round(message.end);
        }
        return obj;
    },
    create(base) {
        return PlayerOutput_PlayerStateChanged_TimeRange.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBasePlayerOutput_PlayerStateChanged_TimeRange();
        message.start = object.start ?? 0;
        message.end = object.end ?? 0;
        return message;
    },
};
function createBasePlayerOutput_PlayerError() {
    return { code: undefined, message: undefined };
}
export const PlayerOutput_PlayerError = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.code !== undefined) {
            writer.uint32(8).int32(message.code);
        }
        if (message.message !== undefined) {
            writer.uint32(18).string(message.message);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlayerOutput_PlayerError();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.code = reader.int32();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.message = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            code: isSet(object.code) ? globalThis.Number(object.code) : undefined,
            message: isSet(object.message) ? globalThis.String(object.message) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.code !== undefined) {
            obj.code = Math.round(message.code);
        }
        if (message.message !== undefined) {
            obj.message = message.message;
        }
        return obj;
    },
    create(base) {
        return PlayerOutput_PlayerError.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBasePlayerOutput_PlayerError();
        message.code = object.code ?? undefined;
        message.message = object.message ?? undefined;
        return message;
    },
};
function createBasePlayerOutput_AvailableAudioTracksChanged() {
    return { tracks: [] };
}
export const PlayerOutput_AvailableAudioTracksChanged = {
    encode(message, writer = _m0.Writer.create()) {
        for (const v of message.tracks) {
            Sdk_MediaTrack.encode(v, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlayerOutput_AvailableAudioTracksChanged();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.tracks.push(Sdk_MediaTrack.decode(reader, reader.uint32()));
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            tracks: globalThis.Array.isArray(object?.tracks) ? object.tracks.map((e) => Sdk_MediaTrack.fromJSON(e)) : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.tracks?.length) {
            obj.tracks = message.tracks.map((e) => Sdk_MediaTrack.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return PlayerOutput_AvailableAudioTracksChanged.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBasePlayerOutput_AvailableAudioTracksChanged();
        message.tracks = object.tracks?.map((e) => Sdk_MediaTrack.fromPartial(e)) || [];
        return message;
    },
};
function createBasePlayerOutput_AvailableSubtitlesTrackChanged() {
    return { tracks: [] };
}
export const PlayerOutput_AvailableSubtitlesTrackChanged = {
    encode(message, writer = _m0.Writer.create()) {
        for (const v of message.tracks) {
            Sdk_MediaTrack.encode(v, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlayerOutput_AvailableSubtitlesTrackChanged();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.tracks.push(Sdk_MediaTrack.decode(reader, reader.uint32()));
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            tracks: globalThis.Array.isArray(object?.tracks) ? object.tracks.map((e) => Sdk_MediaTrack.fromJSON(e)) : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.tracks?.length) {
            obj.tracks = message.tracks.map((e) => Sdk_MediaTrack.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return PlayerOutput_AvailableSubtitlesTrackChanged.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBasePlayerOutput_AvailableSubtitlesTrackChanged();
        message.tracks = object.tracks?.map((e) => Sdk_MediaTrack.fromPartial(e)) || [];
        return message;
    },
};
function createBasePlayerOutput_SelectedAudioTrackChanged() {
    return { track: undefined };
}
export const PlayerOutput_SelectedAudioTrackChanged = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.track !== undefined) {
            Sdk_MediaTrack.encode(message.track, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlayerOutput_SelectedAudioTrackChanged();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.track = Sdk_MediaTrack.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return { track: isSet(object.track) ? Sdk_MediaTrack.fromJSON(object.track) : undefined };
    },
    toJSON(message) {
        const obj = {};
        if (message.track !== undefined) {
            obj.track = Sdk_MediaTrack.toJSON(message.track);
        }
        return obj;
    },
    create(base) {
        return PlayerOutput_SelectedAudioTrackChanged.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBasePlayerOutput_SelectedAudioTrackChanged();
        message.track = (object.track !== undefined && object.track !== null)
            ? Sdk_MediaTrack.fromPartial(object.track)
            : undefined;
        return message;
    },
};
function createBasePlayerOutput_SelectedSubtitlesTrackChanged() {
    return { track: undefined };
}
export const PlayerOutput_SelectedSubtitlesTrackChanged = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.track !== undefined) {
            Sdk_MediaTrack.encode(message.track, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlayerOutput_SelectedSubtitlesTrackChanged();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.track = Sdk_MediaTrack.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return { track: isSet(object.track) ? Sdk_MediaTrack.fromJSON(object.track) : undefined };
    },
    toJSON(message) {
        const obj = {};
        if (message.track !== undefined) {
            obj.track = Sdk_MediaTrack.toJSON(message.track);
        }
        return obj;
    },
    create(base) {
        return PlayerOutput_SelectedSubtitlesTrackChanged.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBasePlayerOutput_SelectedSubtitlesTrackChanged();
        message.track = (object.track !== undefined && object.track !== null)
            ? Sdk_MediaTrack.fromPartial(object.track)
            : undefined;
        return message;
    },
};
function createBasePlayerOutput_AvailableAudioTracks() {
    return { tracks: [] };
}
export const PlayerOutput_AvailableAudioTracks = {
    encode(message, writer = _m0.Writer.create()) {
        for (const v of message.tracks) {
            Sdk_MediaTrack.encode(v, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlayerOutput_AvailableAudioTracks();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.tracks.push(Sdk_MediaTrack.decode(reader, reader.uint32()));
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            tracks: globalThis.Array.isArray(object?.tracks) ? object.tracks.map((e) => Sdk_MediaTrack.fromJSON(e)) : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.tracks?.length) {
            obj.tracks = message.tracks.map((e) => Sdk_MediaTrack.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return PlayerOutput_AvailableAudioTracks.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBasePlayerOutput_AvailableAudioTracks();
        message.tracks = object.tracks?.map((e) => Sdk_MediaTrack.fromPartial(e)) || [];
        return message;
    },
};
function createBasePlayerOutput_SelectedAudioTrack() {
    return { track: undefined };
}
export const PlayerOutput_SelectedAudioTrack = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.track !== undefined) {
            Sdk_MediaTrack.encode(message.track, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlayerOutput_SelectedAudioTrack();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.track = Sdk_MediaTrack.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return { track: isSet(object.track) ? Sdk_MediaTrack.fromJSON(object.track) : undefined };
    },
    toJSON(message) {
        const obj = {};
        if (message.track !== undefined) {
            obj.track = Sdk_MediaTrack.toJSON(message.track);
        }
        return obj;
    },
    create(base) {
        return PlayerOutput_SelectedAudioTrack.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBasePlayerOutput_SelectedAudioTrack();
        message.track = (object.track !== undefined && object.track !== null)
            ? Sdk_MediaTrack.fromPartial(object.track)
            : undefined;
        return message;
    },
};
function createBasePlayerOutput_AvailableSubtitlesTracks() {
    return { tracks: [] };
}
export const PlayerOutput_AvailableSubtitlesTracks = {
    encode(message, writer = _m0.Writer.create()) {
        for (const v of message.tracks) {
            Sdk_MediaTrack.encode(v, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlayerOutput_AvailableSubtitlesTracks();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.tracks.push(Sdk_MediaTrack.decode(reader, reader.uint32()));
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            tracks: globalThis.Array.isArray(object?.tracks) ? object.tracks.map((e) => Sdk_MediaTrack.fromJSON(e)) : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.tracks?.length) {
            obj.tracks = message.tracks.map((e) => Sdk_MediaTrack.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return PlayerOutput_AvailableSubtitlesTracks.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBasePlayerOutput_AvailableSubtitlesTracks();
        message.tracks = object.tracks?.map((e) => Sdk_MediaTrack.fromPartial(e)) || [];
        return message;
    },
};
function createBasePlayerOutput_SelectedSubtitlesTrack() {
    return { track: undefined };
}
export const PlayerOutput_SelectedSubtitlesTrack = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.track !== undefined) {
            Sdk_MediaTrack.encode(message.track, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlayerOutput_SelectedSubtitlesTrack();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.track = Sdk_MediaTrack.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return { track: isSet(object.track) ? Sdk_MediaTrack.fromJSON(object.track) : undefined };
    },
    toJSON(message) {
        const obj = {};
        if (message.track !== undefined) {
            obj.track = Sdk_MediaTrack.toJSON(message.track);
        }
        return obj;
    },
    create(base) {
        return PlayerOutput_SelectedSubtitlesTrack.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBasePlayerOutput_SelectedSubtitlesTrack();
        message.track = (object.track !== undefined && object.track !== null)
            ? Sdk_MediaTrack.fromPartial(object.track)
            : undefined;
        return message;
    },
};
function createBasePlayerOutput_CastMediaTracksChanged() {
    return { tracks: {} };
}
export const PlayerOutput_CastMediaTracksChanged = {
    encode(message, writer = _m0.Writer.create()) {
        Object.entries(message.tracks).forEach(([key, value]) => {
            PlayerOutput_CastMediaTracksChanged_TracksEntry.encode({ key: key, value }, writer.uint32(10).fork())
                .ldelim();
        });
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlayerOutput_CastMediaTracksChanged();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    const entry1 = PlayerOutput_CastMediaTracksChanged_TracksEntry.decode(reader, reader.uint32());
                    if (entry1.value !== undefined) {
                        message.tracks[entry1.key] = entry1.value;
                    }
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            tracks: isObject(object.tracks)
                ? Object.entries(object.tracks).reduce((acc, [key, value]) => {
                    acc[key] = PlayerOutput_CastMediaTracksChanged_CastMediaTracks.fromJSON(value);
                    return acc;
                }, {})
                : {},
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.tracks) {
            const entries = Object.entries(message.tracks);
            if (entries.length > 0) {
                obj.tracks = {};
                entries.forEach(([k, v]) => {
                    obj.tracks[k] = PlayerOutput_CastMediaTracksChanged_CastMediaTracks.toJSON(v);
                });
            }
        }
        return obj;
    },
    create(base) {
        return PlayerOutput_CastMediaTracksChanged.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBasePlayerOutput_CastMediaTracksChanged();
        message.tracks = Object.entries(object.tracks ?? {}).reduce((acc, [key, value]) => {
            if (value !== undefined) {
                acc[key] = PlayerOutput_CastMediaTracksChanged_CastMediaTracks.fromPartial(value);
            }
            return acc;
        }, {});
        return message;
    },
};
function createBasePlayerOutput_CastMediaTracksChanged_CastMediaTracks() {
    return { tracks: [] };
}
export const PlayerOutput_CastMediaTracksChanged_CastMediaTracks = {
    encode(message, writer = _m0.Writer.create()) {
        for (const v of message.tracks) {
            Sdk_CastMediaTrack.encode(v, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlayerOutput_CastMediaTracksChanged_CastMediaTracks();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.tracks.push(Sdk_CastMediaTrack.decode(reader, reader.uint32()));
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            tracks: globalThis.Array.isArray(object?.tracks)
                ? object.tracks.map((e) => Sdk_CastMediaTrack.fromJSON(e))
                : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.tracks?.length) {
            obj.tracks = message.tracks.map((e) => Sdk_CastMediaTrack.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return PlayerOutput_CastMediaTracksChanged_CastMediaTracks.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBasePlayerOutput_CastMediaTracksChanged_CastMediaTracks();
        message.tracks = object.tracks?.map((e) => Sdk_CastMediaTrack.fromPartial(e)) || [];
        return message;
    },
};
function createBasePlayerOutput_CastMediaTracksChanged_TracksEntry() {
    return { key: "", value: undefined };
}
export const PlayerOutput_CastMediaTracksChanged_TracksEntry = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.key !== "") {
            writer.uint32(10).string(message.key);
        }
        if (message.value !== undefined) {
            PlayerOutput_CastMediaTracksChanged_CastMediaTracks.encode(message.value, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlayerOutput_CastMediaTracksChanged_TracksEntry();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.key = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.value = PlayerOutput_CastMediaTracksChanged_CastMediaTracks.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            key: isSet(object.key) ? globalThis.String(object.key) : "",
            value: isSet(object.value)
                ? PlayerOutput_CastMediaTracksChanged_CastMediaTracks.fromJSON(object.value)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.key !== "") {
            obj.key = message.key;
        }
        if (message.value !== undefined) {
            obj.value = PlayerOutput_CastMediaTracksChanged_CastMediaTracks.toJSON(message.value);
        }
        return obj;
    },
    create(base) {
        return PlayerOutput_CastMediaTracksChanged_TracksEntry.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBasePlayerOutput_CastMediaTracksChanged_TracksEntry();
        message.key = object.key ?? "";
        message.value = (object.value !== undefined && object.value !== null)
            ? PlayerOutput_CastMediaTracksChanged_CastMediaTracks.fromPartial(object.value)
            : undefined;
        return message;
    },
};
function createBasePlayerOutput_CastMediaTrackSelectionChanged() {
    return { ids: [] };
}
export const PlayerOutput_CastMediaTrackSelectionChanged = {
    encode(message, writer = _m0.Writer.create()) {
        for (const v of message.ids) {
            writer.uint32(10).string(v);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlayerOutput_CastMediaTrackSelectionChanged();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.ids.push(reader.string());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return { ids: globalThis.Array.isArray(object?.ids) ? object.ids.map((e) => globalThis.String(e)) : [] };
    },
    toJSON(message) {
        const obj = {};
        if (message.ids?.length) {
            obj.ids = message.ids;
        }
        return obj;
    },
    create(base) {
        return PlayerOutput_CastMediaTrackSelectionChanged.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBasePlayerOutput_CastMediaTrackSelectionChanged();
        message.ids = object.ids?.map((e) => e) || [];
        return message;
    },
};
function createBasePlayerOutput_QualityChanged() {
    return { bitrate: 0 };
}
export const PlayerOutput_QualityChanged = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.bitrate !== 0) {
            writer.uint32(8).uint32(message.bitrate);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlayerOutput_QualityChanged();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.bitrate = reader.uint32();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return { bitrate: isSet(object.bitrate) ? globalThis.Number(object.bitrate) : 0 };
    },
    toJSON(message) {
        const obj = {};
        if (message.bitrate !== 0) {
            obj.bitrate = Math.round(message.bitrate);
        }
        return obj;
    },
    create(base) {
        return PlayerOutput_QualityChanged.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBasePlayerOutput_QualityChanged();
        message.bitrate = object.bitrate ?? 0;
        return message;
    },
};
function createBasePlayerOutput_LatencyMetadata() {
    return {
        recorderStart: undefined,
        recorderEnd: undefined,
        transcoderStart: undefined,
        transcoderEnd: undefined,
        packagerEnd: undefined,
        downloadEnd: undefined,
        time: 0,
    };
}
export const PlayerOutput_LatencyMetadata = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.recorderStart !== undefined) {
            writer.uint32(9).double(message.recorderStart);
        }
        if (message.recorderEnd !== undefined) {
            writer.uint32(17).double(message.recorderEnd);
        }
        if (message.transcoderStart !== undefined) {
            writer.uint32(25).double(message.transcoderStart);
        }
        if (message.transcoderEnd !== undefined) {
            writer.uint32(33).double(message.transcoderEnd);
        }
        if (message.packagerEnd !== undefined) {
            writer.uint32(41).double(message.packagerEnd);
        }
        if (message.downloadEnd !== undefined) {
            writer.uint32(49).double(message.downloadEnd);
        }
        if (message.time !== 0) {
            writer.uint32(57).double(message.time);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlayerOutput_LatencyMetadata();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 9) {
                        break;
                    }
                    message.recorderStart = reader.double();
                    continue;
                case 2:
                    if (tag !== 17) {
                        break;
                    }
                    message.recorderEnd = reader.double();
                    continue;
                case 3:
                    if (tag !== 25) {
                        break;
                    }
                    message.transcoderStart = reader.double();
                    continue;
                case 4:
                    if (tag !== 33) {
                        break;
                    }
                    message.transcoderEnd = reader.double();
                    continue;
                case 5:
                    if (tag !== 41) {
                        break;
                    }
                    message.packagerEnd = reader.double();
                    continue;
                case 6:
                    if (tag !== 49) {
                        break;
                    }
                    message.downloadEnd = reader.double();
                    continue;
                case 7:
                    if (tag !== 57) {
                        break;
                    }
                    message.time = reader.double();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            recorderStart: isSet(object.recorderStart) ? globalThis.Number(object.recorderStart) : undefined,
            recorderEnd: isSet(object.recorderEnd) ? globalThis.Number(object.recorderEnd) : undefined,
            transcoderStart: isSet(object.transcoderStart) ? globalThis.Number(object.transcoderStart) : undefined,
            transcoderEnd: isSet(object.transcoderEnd) ? globalThis.Number(object.transcoderEnd) : undefined,
            packagerEnd: isSet(object.packagerEnd) ? globalThis.Number(object.packagerEnd) : undefined,
            downloadEnd: isSet(object.downloadEnd) ? globalThis.Number(object.downloadEnd) : undefined,
            time: isSet(object.time) ? globalThis.Number(object.time) : 0,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.recorderStart !== undefined) {
            obj.recorderStart = message.recorderStart;
        }
        if (message.recorderEnd !== undefined) {
            obj.recorderEnd = message.recorderEnd;
        }
        if (message.transcoderStart !== undefined) {
            obj.transcoderStart = message.transcoderStart;
        }
        if (message.transcoderEnd !== undefined) {
            obj.transcoderEnd = message.transcoderEnd;
        }
        if (message.packagerEnd !== undefined) {
            obj.packagerEnd = message.packagerEnd;
        }
        if (message.downloadEnd !== undefined) {
            obj.downloadEnd = message.downloadEnd;
        }
        if (message.time !== 0) {
            obj.time = message.time;
        }
        return obj;
    },
    create(base) {
        return PlayerOutput_LatencyMetadata.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBasePlayerOutput_LatencyMetadata();
        message.recorderStart = object.recorderStart ?? undefined;
        message.recorderEnd = object.recorderEnd ?? undefined;
        message.transcoderStart = object.transcoderStart ?? undefined;
        message.transcoderEnd = object.transcoderEnd ?? undefined;
        message.packagerEnd = object.packagerEnd ?? undefined;
        message.downloadEnd = object.downloadEnd ?? undefined;
        message.time = object.time ?? 0;
        return message;
    },
};
function createBasePlayerOutput_MediaEnded() {
    return {};
}
export const PlayerOutput_MediaEnded = {
    encode(_, writer = _m0.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlayerOutput_MediaEnded();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return PlayerOutput_MediaEnded.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBasePlayerOutput_MediaEnded();
        return message;
    },
};
function createBasePlayerOutput_Properties() {
    return {
        prePadding: 0,
        postPadding: 0,
        isLive: false,
        assetType: 0,
        currentState: undefined,
        seekableRange: undefined,
        isStatsForNerdsEnabled: false,
        duration: undefined,
        volume: 0,
        currentPosition: undefined,
        canSeekForward: false,
        canSeekBackward: false,
        canPause: false,
        deviceCapabilities: undefined,
    };
}
export const PlayerOutput_Properties = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.prePadding !== 0) {
            writer.uint32(9).double(message.prePadding);
        }
        if (message.postPadding !== 0) {
            writer.uint32(17).double(message.postPadding);
        }
        if (message.isLive !== false) {
            writer.uint32(24).bool(message.isLive);
        }
        if (message.assetType !== 0) {
            writer.uint32(32).int32(message.assetType);
        }
        if (message.currentState !== undefined) {
            writer.uint32(40).int32(message.currentState);
        }
        if (message.seekableRange !== undefined) {
            PlayerOutput_PlayerStateChanged_TimeRange.encode(message.seekableRange, writer.uint32(50).fork()).ldelim();
        }
        if (message.isStatsForNerdsEnabled !== false) {
            writer.uint32(56).bool(message.isStatsForNerdsEnabled);
        }
        if (message.duration !== undefined) {
            writer.uint32(65).double(message.duration);
        }
        if (message.volume !== 0) {
            writer.uint32(73).double(message.volume);
        }
        if (message.currentPosition !== undefined) {
            writer.uint32(81).double(message.currentPosition);
        }
        if (message.canSeekForward !== false) {
            writer.uint32(88).bool(message.canSeekForward);
        }
        if (message.canSeekBackward !== false) {
            writer.uint32(96).bool(message.canSeekBackward);
        }
        if (message.canPause !== false) {
            writer.uint32(104).bool(message.canPause);
        }
        if (message.deviceCapabilities !== undefined) {
            Sdk_DeviceCapabilities.encode(message.deviceCapabilities, writer.uint32(114).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlayerOutput_Properties();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 9) {
                        break;
                    }
                    message.prePadding = reader.double();
                    continue;
                case 2:
                    if (tag !== 17) {
                        break;
                    }
                    message.postPadding = reader.double();
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.isLive = reader.bool();
                    continue;
                case 4:
                    if (tag !== 32) {
                        break;
                    }
                    message.assetType = reader.int32();
                    continue;
                case 5:
                    if (tag !== 40) {
                        break;
                    }
                    message.currentState = reader.int32();
                    continue;
                case 6:
                    if (tag !== 50) {
                        break;
                    }
                    message.seekableRange = PlayerOutput_PlayerStateChanged_TimeRange.decode(reader, reader.uint32());
                    continue;
                case 7:
                    if (tag !== 56) {
                        break;
                    }
                    message.isStatsForNerdsEnabled = reader.bool();
                    continue;
                case 8:
                    if (tag !== 65) {
                        break;
                    }
                    message.duration = reader.double();
                    continue;
                case 9:
                    if (tag !== 73) {
                        break;
                    }
                    message.volume = reader.double();
                    continue;
                case 10:
                    if (tag !== 81) {
                        break;
                    }
                    message.currentPosition = reader.double();
                    continue;
                case 11:
                    if (tag !== 88) {
                        break;
                    }
                    message.canSeekForward = reader.bool();
                    continue;
                case 12:
                    if (tag !== 96) {
                        break;
                    }
                    message.canSeekBackward = reader.bool();
                    continue;
                case 13:
                    if (tag !== 104) {
                        break;
                    }
                    message.canPause = reader.bool();
                    continue;
                case 14:
                    if (tag !== 114) {
                        break;
                    }
                    message.deviceCapabilities = Sdk_DeviceCapabilities.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            prePadding: isSet(object.prePadding) ? globalThis.Number(object.prePadding) : 0,
            postPadding: isSet(object.postPadding) ? globalThis.Number(object.postPadding) : 0,
            isLive: isSet(object.isLive) ? globalThis.Boolean(object.isLive) : false,
            assetType: isSet(object.assetType) ? sdk_AssetTypeFromJSON(object.assetType) : 0,
            currentState: isSet(object.currentState)
                ? playerOutput_PlaybackStateChanged_StateFromJSON(object.currentState)
                : undefined,
            seekableRange: isSet(object.seekableRange)
                ? PlayerOutput_PlayerStateChanged_TimeRange.fromJSON(object.seekableRange)
                : undefined,
            isStatsForNerdsEnabled: isSet(object.isStatsForNerdsEnabled)
                ? globalThis.Boolean(object.isStatsForNerdsEnabled)
                : false,
            duration: isSet(object.duration) ? globalThis.Number(object.duration) : undefined,
            volume: isSet(object.volume) ? globalThis.Number(object.volume) : 0,
            currentPosition: isSet(object.currentPosition) ? globalThis.Number(object.currentPosition) : undefined,
            canSeekForward: isSet(object.canSeekForward) ? globalThis.Boolean(object.canSeekForward) : false,
            canSeekBackward: isSet(object.canSeekBackward) ? globalThis.Boolean(object.canSeekBackward) : false,
            canPause: isSet(object.canPause) ? globalThis.Boolean(object.canPause) : false,
            deviceCapabilities: isSet(object.deviceCapabilities)
                ? Sdk_DeviceCapabilities.fromJSON(object.deviceCapabilities)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.prePadding !== 0) {
            obj.prePadding = message.prePadding;
        }
        if (message.postPadding !== 0) {
            obj.postPadding = message.postPadding;
        }
        if (message.isLive !== false) {
            obj.isLive = message.isLive;
        }
        if (message.assetType !== 0) {
            obj.assetType = sdk_AssetTypeToJSON(message.assetType);
        }
        if (message.currentState !== undefined) {
            obj.currentState = playerOutput_PlaybackStateChanged_StateToJSON(message.currentState);
        }
        if (message.seekableRange !== undefined) {
            obj.seekableRange = PlayerOutput_PlayerStateChanged_TimeRange.toJSON(message.seekableRange);
        }
        if (message.isStatsForNerdsEnabled !== false) {
            obj.isStatsForNerdsEnabled = message.isStatsForNerdsEnabled;
        }
        if (message.duration !== undefined) {
            obj.duration = message.duration;
        }
        if (message.volume !== 0) {
            obj.volume = message.volume;
        }
        if (message.currentPosition !== undefined) {
            obj.currentPosition = message.currentPosition;
        }
        if (message.canSeekForward !== false) {
            obj.canSeekForward = message.canSeekForward;
        }
        if (message.canSeekBackward !== false) {
            obj.canSeekBackward = message.canSeekBackward;
        }
        if (message.canPause !== false) {
            obj.canPause = message.canPause;
        }
        if (message.deviceCapabilities !== undefined) {
            obj.deviceCapabilities = Sdk_DeviceCapabilities.toJSON(message.deviceCapabilities);
        }
        return obj;
    },
    create(base) {
        return PlayerOutput_Properties.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBasePlayerOutput_Properties();
        message.prePadding = object.prePadding ?? 0;
        message.postPadding = object.postPadding ?? 0;
        message.isLive = object.isLive ?? false;
        message.assetType = object.assetType ?? 0;
        message.currentState = object.currentState ?? undefined;
        message.seekableRange = (object.seekableRange !== undefined && object.seekableRange !== null)
            ? PlayerOutput_PlayerStateChanged_TimeRange.fromPartial(object.seekableRange)
            : undefined;
        message.isStatsForNerdsEnabled = object.isStatsForNerdsEnabled ?? false;
        message.duration = object.duration ?? undefined;
        message.volume = object.volume ?? 0;
        message.currentPosition = object.currentPosition ?? undefined;
        message.canSeekForward = object.canSeekForward ?? false;
        message.canSeekBackward = object.canSeekBackward ?? false;
        message.canPause = object.canPause ?? false;
        message.deviceCapabilities = (object.deviceCapabilities !== undefined && object.deviceCapabilities !== null)
            ? Sdk_DeviceCapabilities.fromPartial(object.deviceCapabilities)
            : undefined;
        return message;
    },
};
function createBasePlayerOutput_SeekResult() {
    return {
        allowed: undefined,
        allowedByDate: undefined,
        forwardSeekingNotAllowed: undefined,
        gt12Allowed: undefined,
        gt12SeekToAdBreak: undefined,
        gt12SeekToAndDisplayAdBreak: undefined,
        gt12Forbidden: undefined,
        streamChange: undefined,
    };
}
export const PlayerOutput_SeekResult = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.allowed !== undefined) {
            PlayerOutput_SeekResult_Allowed.encode(message.allowed, writer.uint32(10).fork()).ldelim();
        }
        if (message.allowedByDate !== undefined) {
            PlayerOutput_SeekResult_AllowedByDate.encode(message.allowedByDate, writer.uint32(18).fork()).ldelim();
        }
        if (message.forwardSeekingNotAllowed !== undefined) {
            PlayerOutput_SeekResult_ForwardSeekingNotAllowed.encode(message.forwardSeekingNotAllowed, writer.uint32(26).fork()).ldelim();
        }
        if (message.gt12Allowed !== undefined) {
            PlayerOutput_SeekResult_GT12Allowed.encode(message.gt12Allowed, writer.uint32(34).fork()).ldelim();
        }
        if (message.gt12SeekToAdBreak !== undefined) {
            PlayerOutput_SeekResult_GT12SeekToAdBreak.encode(message.gt12SeekToAdBreak, writer.uint32(42).fork()).ldelim();
        }
        if (message.gt12SeekToAndDisplayAdBreak !== undefined) {
            PlayerOutput_SeekResult_GT12SeekToAndDisplayAdBreak.encode(message.gt12SeekToAndDisplayAdBreak, writer.uint32(50).fork()).ldelim();
        }
        if (message.gt12Forbidden !== undefined) {
            PlayerOutput_SeekResult_GT12Forbidden.encode(message.gt12Forbidden, writer.uint32(58).fork()).ldelim();
        }
        if (message.streamChange !== undefined) {
            PlayerOutput_SeekResult_StreamChange.encode(message.streamChange, writer.uint32(66).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlayerOutput_SeekResult();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.allowed = PlayerOutput_SeekResult_Allowed.decode(reader, reader.uint32());
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.allowedByDate = PlayerOutput_SeekResult_AllowedByDate.decode(reader, reader.uint32());
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.forwardSeekingNotAllowed = PlayerOutput_SeekResult_ForwardSeekingNotAllowed.decode(reader, reader.uint32());
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.gt12Allowed = PlayerOutput_SeekResult_GT12Allowed.decode(reader, reader.uint32());
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.gt12SeekToAdBreak = PlayerOutput_SeekResult_GT12SeekToAdBreak.decode(reader, reader.uint32());
                    continue;
                case 6:
                    if (tag !== 50) {
                        break;
                    }
                    message.gt12SeekToAndDisplayAdBreak = PlayerOutput_SeekResult_GT12SeekToAndDisplayAdBreak.decode(reader, reader.uint32());
                    continue;
                case 7:
                    if (tag !== 58) {
                        break;
                    }
                    message.gt12Forbidden = PlayerOutput_SeekResult_GT12Forbidden.decode(reader, reader.uint32());
                    continue;
                case 8:
                    if (tag !== 66) {
                        break;
                    }
                    message.streamChange = PlayerOutput_SeekResult_StreamChange.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            allowed: isSet(object.allowed) ? PlayerOutput_SeekResult_Allowed.fromJSON(object.allowed) : undefined,
            allowedByDate: isSet(object.allowedByDate)
                ? PlayerOutput_SeekResult_AllowedByDate.fromJSON(object.allowedByDate)
                : undefined,
            forwardSeekingNotAllowed: isSet(object.forwardSeekingNotAllowed)
                ? PlayerOutput_SeekResult_ForwardSeekingNotAllowed.fromJSON(object.forwardSeekingNotAllowed)
                : undefined,
            gt12Allowed: isSet(object.gt12Allowed)
                ? PlayerOutput_SeekResult_GT12Allowed.fromJSON(object.gt12Allowed)
                : undefined,
            gt12SeekToAdBreak: isSet(object.gt12SeekToAdBreak)
                ? PlayerOutput_SeekResult_GT12SeekToAdBreak.fromJSON(object.gt12SeekToAdBreak)
                : undefined,
            gt12SeekToAndDisplayAdBreak: isSet(object.gt12SeekToAndDisplayAdBreak)
                ? PlayerOutput_SeekResult_GT12SeekToAndDisplayAdBreak.fromJSON(object.gt12SeekToAndDisplayAdBreak)
                : undefined,
            gt12Forbidden: isSet(object.gt12Forbidden)
                ? PlayerOutput_SeekResult_GT12Forbidden.fromJSON(object.gt12Forbidden)
                : undefined,
            streamChange: isSet(object.streamChange)
                ? PlayerOutput_SeekResult_StreamChange.fromJSON(object.streamChange)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.allowed !== undefined) {
            obj.allowed = PlayerOutput_SeekResult_Allowed.toJSON(message.allowed);
        }
        if (message.allowedByDate !== undefined) {
            obj.allowedByDate = PlayerOutput_SeekResult_AllowedByDate.toJSON(message.allowedByDate);
        }
        if (message.forwardSeekingNotAllowed !== undefined) {
            obj.forwardSeekingNotAllowed = PlayerOutput_SeekResult_ForwardSeekingNotAllowed.toJSON(message.forwardSeekingNotAllowed);
        }
        if (message.gt12Allowed !== undefined) {
            obj.gt12Allowed = PlayerOutput_SeekResult_GT12Allowed.toJSON(message.gt12Allowed);
        }
        if (message.gt12SeekToAdBreak !== undefined) {
            obj.gt12SeekToAdBreak = PlayerOutput_SeekResult_GT12SeekToAdBreak.toJSON(message.gt12SeekToAdBreak);
        }
        if (message.gt12SeekToAndDisplayAdBreak !== undefined) {
            obj.gt12SeekToAndDisplayAdBreak = PlayerOutput_SeekResult_GT12SeekToAndDisplayAdBreak.toJSON(message.gt12SeekToAndDisplayAdBreak);
        }
        if (message.gt12Forbidden !== undefined) {
            obj.gt12Forbidden = PlayerOutput_SeekResult_GT12Forbidden.toJSON(message.gt12Forbidden);
        }
        if (message.streamChange !== undefined) {
            obj.streamChange = PlayerOutput_SeekResult_StreamChange.toJSON(message.streamChange);
        }
        return obj;
    },
    create(base) {
        return PlayerOutput_SeekResult.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBasePlayerOutput_SeekResult();
        message.allowed = (object.allowed !== undefined && object.allowed !== null)
            ? PlayerOutput_SeekResult_Allowed.fromPartial(object.allowed)
            : undefined;
        message.allowedByDate = (object.allowedByDate !== undefined && object.allowedByDate !== null)
            ? PlayerOutput_SeekResult_AllowedByDate.fromPartial(object.allowedByDate)
            : undefined;
        message.forwardSeekingNotAllowed =
            (object.forwardSeekingNotAllowed !== undefined && object.forwardSeekingNotAllowed !== null)
                ? PlayerOutput_SeekResult_ForwardSeekingNotAllowed.fromPartial(object.forwardSeekingNotAllowed)
                : undefined;
        message.gt12Allowed = (object.gt12Allowed !== undefined && object.gt12Allowed !== null)
            ? PlayerOutput_SeekResult_GT12Allowed.fromPartial(object.gt12Allowed)
            : undefined;
        message.gt12SeekToAdBreak = (object.gt12SeekToAdBreak !== undefined && object.gt12SeekToAdBreak !== null)
            ? PlayerOutput_SeekResult_GT12SeekToAdBreak.fromPartial(object.gt12SeekToAdBreak)
            : undefined;
        message.gt12SeekToAndDisplayAdBreak =
            (object.gt12SeekToAndDisplayAdBreak !== undefined && object.gt12SeekToAndDisplayAdBreak !== null)
                ? PlayerOutput_SeekResult_GT12SeekToAndDisplayAdBreak.fromPartial(object.gt12SeekToAndDisplayAdBreak)
                : undefined;
        message.gt12Forbidden = (object.gt12Forbidden !== undefined && object.gt12Forbidden !== null)
            ? PlayerOutput_SeekResult_GT12Forbidden.fromPartial(object.gt12Forbidden)
            : undefined;
        message.streamChange = (object.streamChange !== undefined && object.streamChange !== null)
            ? PlayerOutput_SeekResult_StreamChange.fromPartial(object.streamChange)
            : undefined;
        return message;
    },
};
function createBasePlayerOutput_SeekResult_Allowed() {
    return { position: 0 };
}
export const PlayerOutput_SeekResult_Allowed = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.position !== 0) {
            writer.uint32(9).double(message.position);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlayerOutput_SeekResult_Allowed();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 9) {
                        break;
                    }
                    message.position = reader.double();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return { position: isSet(object.position) ? globalThis.Number(object.position) : 0 };
    },
    toJSON(message) {
        const obj = {};
        if (message.position !== 0) {
            obj.position = message.position;
        }
        return obj;
    },
    create(base) {
        return PlayerOutput_SeekResult_Allowed.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBasePlayerOutput_SeekResult_Allowed();
        message.position = object.position ?? 0;
        return message;
    },
};
function createBasePlayerOutput_SeekResult_AllowedByDate() {
    return { timestamp: 0 };
}
export const PlayerOutput_SeekResult_AllowedByDate = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.timestamp !== 0) {
            writer.uint32(8).uint32(message.timestamp);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlayerOutput_SeekResult_AllowedByDate();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.timestamp = reader.uint32();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return { timestamp: isSet(object.timestamp) ? globalThis.Number(object.timestamp) : 0 };
    },
    toJSON(message) {
        const obj = {};
        if (message.timestamp !== 0) {
            obj.timestamp = Math.round(message.timestamp);
        }
        return obj;
    },
    create(base) {
        return PlayerOutput_SeekResult_AllowedByDate.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBasePlayerOutput_SeekResult_AllowedByDate();
        message.timestamp = object.timestamp ?? 0;
        return message;
    },
};
function createBasePlayerOutput_SeekResult_ForwardSeekingNotAllowed() {
    return {};
}
export const PlayerOutput_SeekResult_ForwardSeekingNotAllowed = {
    encode(_, writer = _m0.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlayerOutput_SeekResult_ForwardSeekingNotAllowed();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return PlayerOutput_SeekResult_ForwardSeekingNotAllowed.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBasePlayerOutput_SeekResult_ForwardSeekingNotAllowed();
        return message;
    },
};
function createBasePlayerOutput_SeekResult_GT12Allowed() {
    return { position: 0 };
}
export const PlayerOutput_SeekResult_GT12Allowed = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.position !== 0) {
            writer.uint32(9).double(message.position);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlayerOutput_SeekResult_GT12Allowed();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 9) {
                        break;
                    }
                    message.position = reader.double();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return { position: isSet(object.position) ? globalThis.Number(object.position) : 0 };
    },
    toJSON(message) {
        const obj = {};
        if (message.position !== 0) {
            obj.position = message.position;
        }
        return obj;
    },
    create(base) {
        return PlayerOutput_SeekResult_GT12Allowed.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBasePlayerOutput_SeekResult_GT12Allowed();
        message.position = object.position ?? 0;
        return message;
    },
};
function createBasePlayerOutput_SeekResult_GT12SeekToAdBreak() {
    return { position: 0 };
}
export const PlayerOutput_SeekResult_GT12SeekToAdBreak = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.position !== 0) {
            writer.uint32(9).double(message.position);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlayerOutput_SeekResult_GT12SeekToAdBreak();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 9) {
                        break;
                    }
                    message.position = reader.double();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return { position: isSet(object.position) ? globalThis.Number(object.position) : 0 };
    },
    toJSON(message) {
        const obj = {};
        if (message.position !== 0) {
            obj.position = message.position;
        }
        return obj;
    },
    create(base) {
        return PlayerOutput_SeekResult_GT12SeekToAdBreak.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBasePlayerOutput_SeekResult_GT12SeekToAdBreak();
        message.position = object.position ?? 0;
        return message;
    },
};
function createBasePlayerOutput_SeekResult_GT12SeekToAndDisplayAdBreak() {
    return { position: 0, adBreak: "", isChannelAd: undefined, maxDuration: undefined };
}
export const PlayerOutput_SeekResult_GT12SeekToAndDisplayAdBreak = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.position !== 0) {
            writer.uint32(9).double(message.position);
        }
        if (message.adBreak !== "") {
            writer.uint32(18).string(message.adBreak);
        }
        if (message.isChannelAd !== undefined) {
            writer.uint32(24).bool(message.isChannelAd);
        }
        if (message.maxDuration !== undefined) {
            writer.uint32(33).double(message.maxDuration);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlayerOutput_SeekResult_GT12SeekToAndDisplayAdBreak();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 9) {
                        break;
                    }
                    message.position = reader.double();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.adBreak = reader.string();
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.isChannelAd = reader.bool();
                    continue;
                case 4:
                    if (tag !== 33) {
                        break;
                    }
                    message.maxDuration = reader.double();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            position: isSet(object.position) ? globalThis.Number(object.position) : 0,
            adBreak: isSet(object.adBreak) ? globalThis.String(object.adBreak) : "",
            isChannelAd: isSet(object.isChannelAd) ? globalThis.Boolean(object.isChannelAd) : undefined,
            maxDuration: isSet(object.maxDuration) ? globalThis.Number(object.maxDuration) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.position !== 0) {
            obj.position = message.position;
        }
        if (message.adBreak !== "") {
            obj.adBreak = message.adBreak;
        }
        if (message.isChannelAd !== undefined) {
            obj.isChannelAd = message.isChannelAd;
        }
        if (message.maxDuration !== undefined) {
            obj.maxDuration = message.maxDuration;
        }
        return obj;
    },
    create(base) {
        return PlayerOutput_SeekResult_GT12SeekToAndDisplayAdBreak.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBasePlayerOutput_SeekResult_GT12SeekToAndDisplayAdBreak();
        message.position = object.position ?? 0;
        message.adBreak = object.adBreak ?? "";
        message.isChannelAd = object.isChannelAd ?? undefined;
        message.maxDuration = object.maxDuration ?? undefined;
        return message;
    },
};
function createBasePlayerOutput_SeekResult_GT12Forbidden() {
    return {};
}
export const PlayerOutput_SeekResult_GT12Forbidden = {
    encode(_, writer = _m0.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlayerOutput_SeekResult_GT12Forbidden();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return PlayerOutput_SeekResult_GT12Forbidden.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBasePlayerOutput_SeekResult_GT12Forbidden();
        return message;
    },
};
function createBasePlayerOutput_SeekResult_StreamChange() {
    return {};
}
export const PlayerOutput_SeekResult_StreamChange = {
    encode(_, writer = _m0.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlayerOutput_SeekResult_StreamChange();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return PlayerOutput_SeekResult_StreamChange.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBasePlayerOutput_SeekResult_StreamChange();
        return message;
    },
};
function createBasePlayerOutput_AdUniversalAdId() {
    return { adIdValue: "", adIdRegistry: "" };
}
export const PlayerOutput_AdUniversalAdId = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.adIdValue !== "") {
            writer.uint32(10).string(message.adIdValue);
        }
        if (message.adIdRegistry !== "") {
            writer.uint32(18).string(message.adIdRegistry);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlayerOutput_AdUniversalAdId();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.adIdValue = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.adIdRegistry = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            adIdValue: isSet(object.adIdValue) ? globalThis.String(object.adIdValue) : "",
            adIdRegistry: isSet(object.adIdRegistry) ? globalThis.String(object.adIdRegistry) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.adIdValue !== "") {
            obj.adIdValue = message.adIdValue;
        }
        if (message.adIdRegistry !== "") {
            obj.adIdRegistry = message.adIdRegistry;
        }
        return obj;
    },
    create(base) {
        return PlayerOutput_AdUniversalAdId.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBasePlayerOutput_AdUniversalAdId();
        message.adIdValue = object.adIdValue ?? "";
        message.adIdRegistry = object.adIdRegistry ?? "";
        return message;
    },
};
function createBasePlayerOutput_AdPodInfo() {
    return { totalAds: 0, adPosition: 0, isBumper: false, podIndex: 0, timeOffset: 0, maxDuration: 0 };
}
export const PlayerOutput_AdPodInfo = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.totalAds !== 0) {
            writer.uint32(8).int32(message.totalAds);
        }
        if (message.adPosition !== 0) {
            writer.uint32(16).int32(message.adPosition);
        }
        if (message.isBumper !== false) {
            writer.uint32(24).bool(message.isBumper);
        }
        if (message.podIndex !== 0) {
            writer.uint32(32).int32(message.podIndex);
        }
        if (message.timeOffset !== 0) {
            writer.uint32(41).double(message.timeOffset);
        }
        if (message.maxDuration !== 0) {
            writer.uint32(49).double(message.maxDuration);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlayerOutput_AdPodInfo();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.totalAds = reader.int32();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.adPosition = reader.int32();
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.isBumper = reader.bool();
                    continue;
                case 4:
                    if (tag !== 32) {
                        break;
                    }
                    message.podIndex = reader.int32();
                    continue;
                case 5:
                    if (tag !== 41) {
                        break;
                    }
                    message.timeOffset = reader.double();
                    continue;
                case 6:
                    if (tag !== 49) {
                        break;
                    }
                    message.maxDuration = reader.double();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            totalAds: isSet(object.totalAds) ? globalThis.Number(object.totalAds) : 0,
            adPosition: isSet(object.adPosition) ? globalThis.Number(object.adPosition) : 0,
            isBumper: isSet(object.isBumper) ? globalThis.Boolean(object.isBumper) : false,
            podIndex: isSet(object.podIndex) ? globalThis.Number(object.podIndex) : 0,
            timeOffset: isSet(object.timeOffset) ? globalThis.Number(object.timeOffset) : 0,
            maxDuration: isSet(object.maxDuration) ? globalThis.Number(object.maxDuration) : 0,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.totalAds !== 0) {
            obj.totalAds = Math.round(message.totalAds);
        }
        if (message.adPosition !== 0) {
            obj.adPosition = Math.round(message.adPosition);
        }
        if (message.isBumper !== false) {
            obj.isBumper = message.isBumper;
        }
        if (message.podIndex !== 0) {
            obj.podIndex = Math.round(message.podIndex);
        }
        if (message.timeOffset !== 0) {
            obj.timeOffset = message.timeOffset;
        }
        if (message.maxDuration !== 0) {
            obj.maxDuration = message.maxDuration;
        }
        return obj;
    },
    create(base) {
        return PlayerOutput_AdPodInfo.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBasePlayerOutput_AdPodInfo();
        message.totalAds = object.totalAds ?? 0;
        message.adPosition = object.adPosition ?? 0;
        message.isBumper = object.isBumper ?? false;
        message.podIndex = object.podIndex ?? 0;
        message.timeOffset = object.timeOffset ?? 0;
        message.maxDuration = object.maxDuration ?? 0;
        return message;
    },
};
function createBasePlayerOutput_AdInfo() {
    return {
        adId: "",
        adTitle: "",
        adDescription: "",
        adSystem: "",
        contentType: "",
        duration: 0,
        width: 0,
        height: 0,
        vastMediaWidth: 0,
        vastMediaHeight: 0,
        vastMediaBitrate: 0,
        linear: false,
        skippable: false,
        skipTimeOffset: 0,
        adPodInfo: undefined,
        traffickingParameters: "",
        creativeAdId: "",
        universalAdIds: [],
    };
}
export const PlayerOutput_AdInfo = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.adId !== "") {
            writer.uint32(10).string(message.adId);
        }
        if (message.adTitle !== "") {
            writer.uint32(18).string(message.adTitle);
        }
        if (message.adDescription !== "") {
            writer.uint32(26).string(message.adDescription);
        }
        if (message.adSystem !== "") {
            writer.uint32(34).string(message.adSystem);
        }
        if (message.contentType !== "") {
            writer.uint32(42).string(message.contentType);
        }
        if (message.duration !== 0) {
            writer.uint32(49).double(message.duration);
        }
        if (message.width !== 0) {
            writer.uint32(56).int32(message.width);
        }
        if (message.height !== 0) {
            writer.uint32(64).int32(message.height);
        }
        if (message.vastMediaWidth !== 0) {
            writer.uint32(72).int32(message.vastMediaWidth);
        }
        if (message.vastMediaHeight !== 0) {
            writer.uint32(80).int32(message.vastMediaHeight);
        }
        if (message.vastMediaBitrate !== 0) {
            writer.uint32(88).int32(message.vastMediaBitrate);
        }
        if (message.linear !== false) {
            writer.uint32(96).bool(message.linear);
        }
        if (message.skippable !== false) {
            writer.uint32(104).bool(message.skippable);
        }
        if (message.skipTimeOffset !== 0) {
            writer.uint32(113).double(message.skipTimeOffset);
        }
        if (message.adPodInfo !== undefined) {
            PlayerOutput_AdPodInfo.encode(message.adPodInfo, writer.uint32(122).fork()).ldelim();
        }
        if (message.traffickingParameters !== "") {
            writer.uint32(130).string(message.traffickingParameters);
        }
        if (message.creativeAdId !== "") {
            writer.uint32(138).string(message.creativeAdId);
        }
        for (const v of message.universalAdIds) {
            PlayerOutput_AdUniversalAdId.encode(v, writer.uint32(146).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlayerOutput_AdInfo();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.adId = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.adTitle = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.adDescription = reader.string();
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.adSystem = reader.string();
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.contentType = reader.string();
                    continue;
                case 6:
                    if (tag !== 49) {
                        break;
                    }
                    message.duration = reader.double();
                    continue;
                case 7:
                    if (tag !== 56) {
                        break;
                    }
                    message.width = reader.int32();
                    continue;
                case 8:
                    if (tag !== 64) {
                        break;
                    }
                    message.height = reader.int32();
                    continue;
                case 9:
                    if (tag !== 72) {
                        break;
                    }
                    message.vastMediaWidth = reader.int32();
                    continue;
                case 10:
                    if (tag !== 80) {
                        break;
                    }
                    message.vastMediaHeight = reader.int32();
                    continue;
                case 11:
                    if (tag !== 88) {
                        break;
                    }
                    message.vastMediaBitrate = reader.int32();
                    continue;
                case 12:
                    if (tag !== 96) {
                        break;
                    }
                    message.linear = reader.bool();
                    continue;
                case 13:
                    if (tag !== 104) {
                        break;
                    }
                    message.skippable = reader.bool();
                    continue;
                case 14:
                    if (tag !== 113) {
                        break;
                    }
                    message.skipTimeOffset = reader.double();
                    continue;
                case 15:
                    if (tag !== 122) {
                        break;
                    }
                    message.adPodInfo = PlayerOutput_AdPodInfo.decode(reader, reader.uint32());
                    continue;
                case 16:
                    if (tag !== 130) {
                        break;
                    }
                    message.traffickingParameters = reader.string();
                    continue;
                case 17:
                    if (tag !== 138) {
                        break;
                    }
                    message.creativeAdId = reader.string();
                    continue;
                case 18:
                    if (tag !== 146) {
                        break;
                    }
                    message.universalAdIds.push(PlayerOutput_AdUniversalAdId.decode(reader, reader.uint32()));
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            adId: isSet(object.adId) ? globalThis.String(object.adId) : "",
            adTitle: isSet(object.adTitle) ? globalThis.String(object.adTitle) : "",
            adDescription: isSet(object.adDescription) ? globalThis.String(object.adDescription) : "",
            adSystem: isSet(object.adSystem) ? globalThis.String(object.adSystem) : "",
            contentType: isSet(object.contentType) ? globalThis.String(object.contentType) : "",
            duration: isSet(object.duration) ? globalThis.Number(object.duration) : 0,
            width: isSet(object.width) ? globalThis.Number(object.width) : 0,
            height: isSet(object.height) ? globalThis.Number(object.height) : 0,
            vastMediaWidth: isSet(object.vastMediaWidth) ? globalThis.Number(object.vastMediaWidth) : 0,
            vastMediaHeight: isSet(object.vastMediaHeight) ? globalThis.Number(object.vastMediaHeight) : 0,
            vastMediaBitrate: isSet(object.vastMediaBitrate) ? globalThis.Number(object.vastMediaBitrate) : 0,
            linear: isSet(object.linear) ? globalThis.Boolean(object.linear) : false,
            skippable: isSet(object.skippable) ? globalThis.Boolean(object.skippable) : false,
            skipTimeOffset: isSet(object.skipTimeOffset) ? globalThis.Number(object.skipTimeOffset) : 0,
            adPodInfo: isSet(object.adPodInfo) ? PlayerOutput_AdPodInfo.fromJSON(object.adPodInfo) : undefined,
            traffickingParameters: isSet(object.traffickingParameters) ? globalThis.String(object.traffickingParameters) : "",
            creativeAdId: isSet(object.creativeAdId) ? globalThis.String(object.creativeAdId) : "",
            universalAdIds: globalThis.Array.isArray(object?.universalAdIds)
                ? object.universalAdIds.map((e) => PlayerOutput_AdUniversalAdId.fromJSON(e))
                : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.adId !== "") {
            obj.adId = message.adId;
        }
        if (message.adTitle !== "") {
            obj.adTitle = message.adTitle;
        }
        if (message.adDescription !== "") {
            obj.adDescription = message.adDescription;
        }
        if (message.adSystem !== "") {
            obj.adSystem = message.adSystem;
        }
        if (message.contentType !== "") {
            obj.contentType = message.contentType;
        }
        if (message.duration !== 0) {
            obj.duration = message.duration;
        }
        if (message.width !== 0) {
            obj.width = Math.round(message.width);
        }
        if (message.height !== 0) {
            obj.height = Math.round(message.height);
        }
        if (message.vastMediaWidth !== 0) {
            obj.vastMediaWidth = Math.round(message.vastMediaWidth);
        }
        if (message.vastMediaHeight !== 0) {
            obj.vastMediaHeight = Math.round(message.vastMediaHeight);
        }
        if (message.vastMediaBitrate !== 0) {
            obj.vastMediaBitrate = Math.round(message.vastMediaBitrate);
        }
        if (message.linear !== false) {
            obj.linear = message.linear;
        }
        if (message.skippable !== false) {
            obj.skippable = message.skippable;
        }
        if (message.skipTimeOffset !== 0) {
            obj.skipTimeOffset = message.skipTimeOffset;
        }
        if (message.adPodInfo !== undefined) {
            obj.adPodInfo = PlayerOutput_AdPodInfo.toJSON(message.adPodInfo);
        }
        if (message.traffickingParameters !== "") {
            obj.traffickingParameters = message.traffickingParameters;
        }
        if (message.creativeAdId !== "") {
            obj.creativeAdId = message.creativeAdId;
        }
        if (message.universalAdIds?.length) {
            obj.universalAdIds = message.universalAdIds.map((e) => PlayerOutput_AdUniversalAdId.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return PlayerOutput_AdInfo.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBasePlayerOutput_AdInfo();
        message.adId = object.adId ?? "";
        message.adTitle = object.adTitle ?? "";
        message.adDescription = object.adDescription ?? "";
        message.adSystem = object.adSystem ?? "";
        message.contentType = object.contentType ?? "";
        message.duration = object.duration ?? 0;
        message.width = object.width ?? 0;
        message.height = object.height ?? 0;
        message.vastMediaWidth = object.vastMediaWidth ?? 0;
        message.vastMediaHeight = object.vastMediaHeight ?? 0;
        message.vastMediaBitrate = object.vastMediaBitrate ?? 0;
        message.linear = object.linear ?? false;
        message.skippable = object.skippable ?? false;
        message.skipTimeOffset = object.skipTimeOffset ?? 0;
        message.adPodInfo = (object.adPodInfo !== undefined && object.adPodInfo !== null)
            ? PlayerOutput_AdPodInfo.fromPartial(object.adPodInfo)
            : undefined;
        message.traffickingParameters = object.traffickingParameters ?? "";
        message.creativeAdId = object.creativeAdId ?? "";
        message.universalAdIds = object.universalAdIds?.map((e) => PlayerOutput_AdUniversalAdId.fromPartial(e)) || [];
        return message;
    },
};
function createBasePlayerOutput_AdBreakData() {
    return { adType: 0, isChannelAd: undefined, maxDuration: undefined };
}
export const PlayerOutput_AdBreakData = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.adType !== 0) {
            writer.uint32(16).int32(message.adType);
        }
        if (message.isChannelAd !== undefined) {
            writer.uint32(32).bool(message.isChannelAd);
        }
        if (message.maxDuration !== undefined) {
            writer.uint32(41).double(message.maxDuration);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlayerOutput_AdBreakData();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.adType = reader.int32();
                    continue;
                case 4:
                    if (tag !== 32) {
                        break;
                    }
                    message.isChannelAd = reader.bool();
                    continue;
                case 5:
                    if (tag !== 41) {
                        break;
                    }
                    message.maxDuration = reader.double();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            adType: isSet(object.adType) ? playerOutput_AdTypeFromJSON(object.adType) : 0,
            isChannelAd: isSet(object.isChannelAd) ? globalThis.Boolean(object.isChannelAd) : undefined,
            maxDuration: isSet(object.maxDuration) ? globalThis.Number(object.maxDuration) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.adType !== 0) {
            obj.adType = playerOutput_AdTypeToJSON(message.adType);
        }
        if (message.isChannelAd !== undefined) {
            obj.isChannelAd = message.isChannelAd;
        }
        if (message.maxDuration !== undefined) {
            obj.maxDuration = message.maxDuration;
        }
        return obj;
    },
    create(base) {
        return PlayerOutput_AdBreakData.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBasePlayerOutput_AdBreakData();
        message.adType = object.adType ?? 0;
        message.isChannelAd = object.isChannelAd ?? undefined;
        message.maxDuration = object.maxDuration ?? undefined;
        return message;
    },
};
function createBasePlayerOutput_AdTypeData() {
    return { adType: 0 };
}
export const PlayerOutput_AdTypeData = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.adType !== 0) {
            writer.uint32(8).int32(message.adType);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlayerOutput_AdTypeData();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.adType = reader.int32();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return { adType: isSet(object.adType) ? playerOutput_AdTypeFromJSON(object.adType) : 0 };
    },
    toJSON(message) {
        const obj = {};
        if (message.adType !== 0) {
            obj.adType = playerOutput_AdTypeToJSON(message.adType);
        }
        return obj;
    },
    create(base) {
        return PlayerOutput_AdTypeData.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBasePlayerOutput_AdTypeData();
        message.adType = object.adType ?? 0;
        return message;
    },
};
function createBasePlayerOutput_AdData() {
    return { adType: 0, adInfo: undefined };
}
export const PlayerOutput_AdData = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.adType !== 0) {
            writer.uint32(16).int32(message.adType);
        }
        if (message.adInfo !== undefined) {
            PlayerOutput_AdInfo.encode(message.adInfo, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlayerOutput_AdData();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.adType = reader.int32();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.adInfo = PlayerOutput_AdInfo.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            adType: isSet(object.adType) ? playerOutput_AdTypeFromJSON(object.adType) : 0,
            adInfo: isSet(object.adInfo) ? PlayerOutput_AdInfo.fromJSON(object.adInfo) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.adType !== 0) {
            obj.adType = playerOutput_AdTypeToJSON(message.adType);
        }
        if (message.adInfo !== undefined) {
            obj.adInfo = PlayerOutput_AdInfo.toJSON(message.adInfo);
        }
        return obj;
    },
    create(base) {
        return PlayerOutput_AdData.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBasePlayerOutput_AdData();
        message.adType = object.adType ?? 0;
        message.adInfo = (object.adInfo !== undefined && object.adInfo !== null)
            ? PlayerOutput_AdInfo.fromPartial(object.adInfo)
            : undefined;
        return message;
    },
};
function createBasePlayerOutput_AdPositionChangedData() {
    return { adType: 0, position: 0, duration: 0 };
}
export const PlayerOutput_AdPositionChangedData = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.adType !== 0) {
            writer.uint32(8).int32(message.adType);
        }
        if (message.position !== 0) {
            writer.uint32(17).double(message.position);
        }
        if (message.duration !== 0) {
            writer.uint32(25).double(message.duration);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlayerOutput_AdPositionChangedData();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.adType = reader.int32();
                    continue;
                case 2:
                    if (tag !== 17) {
                        break;
                    }
                    message.position = reader.double();
                    continue;
                case 3:
                    if (tag !== 25) {
                        break;
                    }
                    message.duration = reader.double();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            adType: isSet(object.adType) ? playerOutput_AdTypeFromJSON(object.adType) : 0,
            position: isSet(object.position) ? globalThis.Number(object.position) : 0,
            duration: isSet(object.duration) ? globalThis.Number(object.duration) : 0,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.adType !== 0) {
            obj.adType = playerOutput_AdTypeToJSON(message.adType);
        }
        if (message.position !== 0) {
            obj.position = message.position;
        }
        if (message.duration !== 0) {
            obj.duration = message.duration;
        }
        return obj;
    },
    create(base) {
        return PlayerOutput_AdPositionChangedData.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBasePlayerOutput_AdPositionChangedData();
        message.adType = object.adType ?? 0;
        message.position = object.position ?? 0;
        message.duration = object.duration ?? 0;
        return message;
    },
};
function createBasePlayerOutput_AdTimeData() {
    return { adType: 0, adInfo: undefined, position: 0 };
}
export const PlayerOutput_AdTimeData = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.adType !== 0) {
            writer.uint32(8).int32(message.adType);
        }
        if (message.adInfo !== undefined) {
            PlayerOutput_AdInfo.encode(message.adInfo, writer.uint32(18).fork()).ldelim();
        }
        if (message.position !== 0) {
            writer.uint32(25).double(message.position);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlayerOutput_AdTimeData();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.adType = reader.int32();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.adInfo = PlayerOutput_AdInfo.decode(reader, reader.uint32());
                    continue;
                case 3:
                    if (tag !== 25) {
                        break;
                    }
                    message.position = reader.double();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            adType: isSet(object.adType) ? playerOutput_AdTypeFromJSON(object.adType) : 0,
            adInfo: isSet(object.adInfo) ? PlayerOutput_AdInfo.fromJSON(object.adInfo) : undefined,
            position: isSet(object.position) ? globalThis.Number(object.position) : 0,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.adType !== 0) {
            obj.adType = playerOutput_AdTypeToJSON(message.adType);
        }
        if (message.adInfo !== undefined) {
            obj.adInfo = PlayerOutput_AdInfo.toJSON(message.adInfo);
        }
        if (message.position !== 0) {
            obj.position = message.position;
        }
        return obj;
    },
    create(base) {
        return PlayerOutput_AdTimeData.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBasePlayerOutput_AdTimeData();
        message.adType = object.adType ?? 0;
        message.adInfo = (object.adInfo !== undefined && object.adInfo !== null)
            ? PlayerOutput_AdInfo.fromPartial(object.adInfo)
            : undefined;
        message.position = object.position ?? 0;
        return message;
    },
};
function createBasePlayerOutput_AdErrorData() {
    return { adType: 0, error: undefined };
}
export const PlayerOutput_AdErrorData = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.adType !== 0) {
            writer.uint32(8).int32(message.adType);
        }
        if (message.error !== undefined) {
            PlayerOutput_AdErrorInfo.encode(message.error, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlayerOutput_AdErrorData();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.adType = reader.int32();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.error = PlayerOutput_AdErrorInfo.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            adType: isSet(object.adType) ? playerOutput_AdTypeFromJSON(object.adType) : 0,
            error: isSet(object.error) ? PlayerOutput_AdErrorInfo.fromJSON(object.error) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.adType !== 0) {
            obj.adType = playerOutput_AdTypeToJSON(message.adType);
        }
        if (message.error !== undefined) {
            obj.error = PlayerOutput_AdErrorInfo.toJSON(message.error);
        }
        return obj;
    },
    create(base) {
        return PlayerOutput_AdErrorData.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBasePlayerOutput_AdErrorData();
        message.adType = object.adType ?? 0;
        message.error = (object.error !== undefined && object.error !== null)
            ? PlayerOutput_AdErrorInfo.fromPartial(object.error)
            : undefined;
        return message;
    },
};
function createBasePlayerOutput_CuePoint() {
    return { start: 0, end: undefined };
}
export const PlayerOutput_CuePoint = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.start !== 0) {
            writer.uint32(9).double(message.start);
        }
        if (message.end !== undefined) {
            writer.uint32(17).double(message.end);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlayerOutput_CuePoint();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 9) {
                        break;
                    }
                    message.start = reader.double();
                    continue;
                case 2:
                    if (tag !== 17) {
                        break;
                    }
                    message.end = reader.double();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            start: isSet(object.start) ? globalThis.Number(object.start) : 0,
            end: isSet(object.end) ? globalThis.Number(object.end) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.start !== 0) {
            obj.start = message.start;
        }
        if (message.end !== undefined) {
            obj.end = message.end;
        }
        return obj;
    },
    create(base) {
        return PlayerOutput_CuePoint.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBasePlayerOutput_CuePoint();
        message.start = object.start ?? 0;
        message.end = object.end ?? undefined;
        return message;
    },
};
function createBasePlayerOutput_AdMetadataData() {
    return { adType: 0, cuePoints: [] };
}
export const PlayerOutput_AdMetadataData = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.adType !== 0) {
            writer.uint32(8).int32(message.adType);
        }
        for (const v of message.cuePoints) {
            PlayerOutput_CuePoint.encode(v, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlayerOutput_AdMetadataData();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.adType = reader.int32();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.cuePoints.push(PlayerOutput_CuePoint.decode(reader, reader.uint32()));
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            adType: isSet(object.adType) ? playerOutput_AdTypeFromJSON(object.adType) : 0,
            cuePoints: globalThis.Array.isArray(object?.cuePoints)
                ? object.cuePoints.map((e) => PlayerOutput_CuePoint.fromJSON(e))
                : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.adType !== 0) {
            obj.adType = playerOutput_AdTypeToJSON(message.adType);
        }
        if (message.cuePoints?.length) {
            obj.cuePoints = message.cuePoints.map((e) => PlayerOutput_CuePoint.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return PlayerOutput_AdMetadataData.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBasePlayerOutput_AdMetadataData();
        message.adType = object.adType ?? 0;
        message.cuePoints = object.cuePoints?.map((e) => PlayerOutput_CuePoint.fromPartial(e)) || [];
        return message;
    },
};
function createBasePlayerOutput_AdBreakSkipAvailable() {
    return {};
}
export const PlayerOutput_AdBreakSkipAvailable = {
    encode(_, writer = _m0.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlayerOutput_AdBreakSkipAvailable();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return PlayerOutput_AdBreakSkipAvailable.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBasePlayerOutput_AdBreakSkipAvailable();
        return message;
    },
};
function createBasePlayerOutput_AdBreakSkipUnavailable() {
    return {};
}
export const PlayerOutput_AdBreakSkipUnavailable = {
    encode(_, writer = _m0.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlayerOutput_AdBreakSkipUnavailable();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return PlayerOutput_AdBreakSkipUnavailable.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBasePlayerOutput_AdBreakSkipUnavailable();
        return message;
    },
};
function createBasePlayerOutput_PauseAdData() {
    return { adWidth: 0, adHeight: 0, adUrl: undefined };
}
export const PlayerOutput_PauseAdData = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.adWidth !== 0) {
            writer.uint32(8).int32(message.adWidth);
        }
        if (message.adHeight !== 0) {
            writer.uint32(16).int32(message.adHeight);
        }
        if (message.adUrl !== undefined) {
            writer.uint32(26).string(message.adUrl);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlayerOutput_PauseAdData();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.adWidth = reader.int32();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.adHeight = reader.int32();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.adUrl = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            adWidth: isSet(object.adWidth) ? globalThis.Number(object.adWidth) : 0,
            adHeight: isSet(object.adHeight) ? globalThis.Number(object.adHeight) : 0,
            adUrl: isSet(object.adUrl) ? globalThis.String(object.adUrl) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.adWidth !== 0) {
            obj.adWidth = Math.round(message.adWidth);
        }
        if (message.adHeight !== 0) {
            obj.adHeight = Math.round(message.adHeight);
        }
        if (message.adUrl !== undefined) {
            obj.adUrl = message.adUrl;
        }
        return obj;
    },
    create(base) {
        return PlayerOutput_PauseAdData.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBasePlayerOutput_PauseAdData();
        message.adWidth = object.adWidth ?? 0;
        message.adHeight = object.adHeight ?? 0;
        message.adUrl = object.adUrl ?? undefined;
        return message;
    },
};
function createBasePlayerOutput_AdErrorInfo() {
    return { adId: undefined, code: undefined, message: undefined };
}
export const PlayerOutput_AdErrorInfo = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.adId !== undefined) {
            writer.uint32(10).string(message.adId);
        }
        if (message.code !== undefined) {
            writer.uint32(16).uint32(message.code);
        }
        if (message.message !== undefined) {
            writer.uint32(26).string(message.message);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlayerOutput_AdErrorInfo();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.adId = reader.string();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.code = reader.uint32();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.message = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            adId: isSet(object.adId) ? globalThis.String(object.adId) : undefined,
            code: isSet(object.code) ? globalThis.Number(object.code) : undefined,
            message: isSet(object.message) ? globalThis.String(object.message) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.adId !== undefined) {
            obj.adId = message.adId;
        }
        if (message.code !== undefined) {
            obj.code = Math.round(message.code);
        }
        if (message.message !== undefined) {
            obj.message = message.message;
        }
        return obj;
    },
    create(base) {
        return PlayerOutput_AdErrorInfo.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBasePlayerOutput_AdErrorInfo();
        message.adId = object.adId ?? undefined;
        message.code = object.code ?? undefined;
        message.message = object.message ?? undefined;
        return message;
    },
};
function createBasePlayerOutput_ThumbnailData() {
    return { data: undefined };
}
export const PlayerOutput_ThumbnailData = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.data !== undefined) {
            Sdk_ThumbnailData.encode(message.data, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlayerOutput_ThumbnailData();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.data = Sdk_ThumbnailData.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return { data: isSet(object.data) ? Sdk_ThumbnailData.fromJSON(object.data) : undefined };
    },
    toJSON(message) {
        const obj = {};
        if (message.data !== undefined) {
            obj.data = Sdk_ThumbnailData.toJSON(message.data);
        }
        return obj;
    },
    create(base) {
        return PlayerOutput_ThumbnailData.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBasePlayerOutput_ThumbnailData();
        message.data = (object.data !== undefined && object.data !== null)
            ? Sdk_ThumbnailData.fromPartial(object.data)
            : undefined;
        return message;
    },
};
function isObject(value) {
    return typeof value === "object" && value !== null;
}
function isSet(value) {
    return value !== null && value !== undefined;
}
